<script>
    import Fa from "svelte-fa";
    import ToggleSwitch from "../ToggleSwitch.svelte";
    import ActionBar from "../ui/ActionBar.svelte";
    import Button from "../ui/Button.svelte";
    import Info from "../ui/Info.svelte";
    import Warning from "../ui/Warning.svelte";
    import { faRightToBracket } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";

    export let business;
    export let unsavedChanges;

    const dispatch = createEventDispatcher();
</script>

<ActionBar>

    {#if unsavedChanges}
        {#if !(business?.name && business?.address?.city && business?.address?.houseNumber && business?.address?.street && business?.address?.zip && business?.address?.state?.name && business?.address?.state?.id)}
            <Warning>
                Damit dein Betrieb unseren Nutzern angezeigt werden kann fehlen außerdem noch die folgende Angaben:
                {#if !business?.name}Name des Betriebs, {/if}
                {#if !business?.address?.street}Straße, {/if}
                {#if !business?.address?.houseNumber}Hausnummer, {/if}
                {#if !business?.address?.city}Stadt, {/if}
                {#if !business?.address?.zip}Postleitzahl, {/if}
                {#if !business?.address?.state?.name || !business?.address?.state?.id}Bundesland{/if}
            </Warning>
        {:else}
            <Warning>
                Du hast ungespeicherte Änderungen. 
            </Warning>
        {/if}
        {#if business.visible}
            <Button intent="danger" disabled={true} fw>
                Betrieb verbergen
            </Button>
        {:else }
            <Button intent="primary" disabled={true} fw>
                Veröffentlichen
            </Button>
        {/if}
    {:else}
        {#if business.visible}
            <Button intent="danger" fw on:click={() => {dispatch("hide")}}>
                Betrieb verbergen
            </Button>
        {:else }
            {#if !(business?.name && business?.address?.city && business?.address?.houseNumber && business?.address?.street && business?.address?.zip && business?.address?.state?.name && business?.address?.state?.id)}
                <Warning>
                    Damit dein Betrieb unseren Nutzern angezeigt werden kann fehlen noch die folgende Angaben:
                    {#if !business?.name}Name des Betriebs, {/if}
                    {#if !business?.address?.street}Straße, {/if}
                    {#if !business?.address?.houseNumber}Hausnummer, {/if}
                    {#if !business?.address?.city}Stadt, {/if}
                    {#if !business?.address?.zip}Postleitzahl, {/if}
                    {#if !business?.address?.state?.name || !business?.address?.state?.id}Bundesland{/if}
                </Warning>
                <Button intent="primary" disabled={true} fw on:click={() => {dispatch("publish")}}>
                    Veröffentlichen
                </Button>
            {:else if !business.visible}
                <Button intent="primary" fw on:click={() => {dispatch("publish")}}>
                    Veröffentlichen
                </Button>
            {/if}
        {/if}
    {/if}
</ActionBar>

<style>

</style>